import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Content, DropDownIcon, NavButton, NavTagsContainer } from '../../styles/navbar.style';
import NavigationButtons from '../NavigationButtons';
import { NAV_ITEMS, NAV_TAGS } from '../../constants';
import Chevron_down from '../../../../images/Icons/chevron_down.svg';
import { navigate } from 'gatsby';
import Dropdown from '../Dropdown';
import PropTypes from 'prop-types';
import BrandLogo from '../BrandLogo';

const DROPDOWN_WIDTH = 901;

const DesktopNavbar = ({
    isHomePage,
    getStartedCtaLink,
    activeMenu,
    setActiveMenu,
    openModal,
    ...props
}) => {
    const [dropdownArrowPosition, setDropdownArrowPosition] = useState(false);

    const navRefs = useRef({});
    const navItemsRef = useRef(null);
    const hoverTimeout = useRef(null);

    const onSecondaryButtonClick = () => {
        if (isHomePage) {
            // Scroll to the #contact section
            navigate('/#contact');
        } else {
            openModal('contact');
            onCloseDropdown();
        }
    };

    const openDropdown = (type) => {
        const navTagEl = navRefs?.current?.[type];
        if (!navTagEl) return;

        const navTagRect = navTagEl.getBoundingClientRect();
        const dropdownLeft = window?.innerWidth / 2 - DROPDOWN_WIDTH / 2;
        const arrowOffset = navTagRect.left + navTagRect.width / 2 - dropdownLeft;
        setDropdownArrowPosition(arrowOffset);
        setActiveMenu(type);
    };

    const onMouseLeave = (type) => {
        if (type === NAV_ITEMS.PRICING) return;
        hoverTimeout.current = setTimeout(() => {
            onCloseDropdown();
        }, 150);
    };

    const onMouseEnter = (type) => {
        if (type === NAV_ITEMS.PRICING) return;

        clearTimeout(hoverTimeout.current);
        openDropdown(type);
    };

    const onCloseDropdown = useCallback(() => {
        setActiveMenu('');
        setDropdownArrowPosition(null);
    }, [setActiveMenu]);

    const closeDropdownOnWindowScroll = useCallback(() => {
        if (window.scrollY > 20) {
            onCloseDropdown();
        }
    }, [onCloseDropdown]);

    useEffect(() => {
        if (activeMenu) {
            document.addEventListener('scroll', closeDropdownOnWindowScroll);

            return () => document.removeEventListener('scroll', closeDropdownOnWindowScroll);
        }
    }, [activeMenu, closeDropdownOnWindowScroll]);

    return (
        <>
            <Content>
                <BrandLogo />
                <NavTagsContainer ref={navItemsRef}>
                    {NAV_TAGS.map((item) => (
                        <NavButton
                            key={item.id}
                            ref={(el) => (navRefs.current[item.label] = el)}
                            active={activeMenu === item.label}
                            onMouseEnter={() => onMouseEnter(item.label)}
                            onMouseLeave={() => onMouseLeave(item.label)}
                        >
                            <span>{item.label}</span>
                            {item.label !== NAV_ITEMS.PRICING && (
                                <DropDownIcon src={Chevron_down} alt="chevron-down-icon" />
                            )}
                        </NavButton>
                    ))}
                </NavTagsContainer>
                <NavigationButtons
                    onSecondaryButtonClick={onSecondaryButtonClick}
                    getStartedCtaLink={getStartedCtaLink}
                />
            </Content>
            {activeMenu && (
                <Dropdown
                    activeMenu={activeMenu}
                    position={dropdownArrowPosition}
                    onCloseDropdown={onCloseDropdown}
                    navItemsRef={navItemsRef}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    {...props}
                />
            )}
        </>
    );
};

DesktopNavbar.propTypes = {
    isHomePage: PropTypes.bool,
    getStartedCtaLink: PropTypes.string,
    activeMenu: PropTypes.string,
    setActiveMenu: PropTypes.func,
    openModal: PropTypes.func,
};

export default DesktopNavbar;
